const updates = [
  {
    date: '07-31',
    title: '《星际穿越2》确认定档2027年暑期',
    desc: '诺兰导演回归科幻题材，续集将延续前作的宏大叙事与情感深度，影迷期待值拉满。',
    tag: '新片',
  },
  {
    date: '07-30',
    title: '小草影院片库突破10,000部里程碑',
    desc: '经过团队持续努力，平台收录影片数量刷新纪录，覆盖动作、喜剧、科幻等全品类。',
    tag: '公告',
  },
  {
    date: '07-29',
    title: '暑期档动作大片《破晓行动》口碑爆棚',
    desc: '上映首周票房突破8亿，精彩的打斗场面和紧凑的剧情获得观众一致好评。',
    tag: '热映',
  },
  {
    date: '07-28',
    title: '小草影院上线全新分类标签系统',
    desc: '新增IMDB评分筛选与年代分类功能，帮助用户更精准地找到心仪影片。',
    tag: '更新',
  },
  {
    date: '07-27',
    title: '国产喜剧《笑到停不下来》引发观影热潮',
    desc: '沈腾、马丽再度联手，爆笑剧情让这部暑期喜剧成为近期最受欢迎的合家欢电影。',
    tag: '热映',
  },
  {
    date: '07-26',
    title: '经典动作片《英雄本色》4K修复版上线',
    desc: '周润发、张国荣主演的这部港片经典以全新画质回归，重温那个热血沸腾的年代。',
    tag: '经典',
  },
  {
    date: '07-25',
    title: '小草影院移动端体验全面优化升级',
    desc: '新版适配各类屏幕尺寸，加载速度提升40%，观影体验更加流畅丝滑。',
    tag: '更新',
  },
  {
    date: '07-24',
    title: '科幻巨制《三体》电影版拍摄进展顺利',
    desc: '制作团队透露影片已进入后期阶段，特效制作规模创国产科幻电影新纪录。',
    tag: '新片',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            最新快讯
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            电影圈动态与小草影院最新资讯，不错过任何精彩
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>

          <div className="space-y-6">
            {updates.map((item, i) => (
              <div key={i} className="relative pl-12">
                <div className="absolute left-0 top-1 w-[39px] flex justify-center">
                  <div className="w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
                </div>

                <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span
                      className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                        item.tag === '热映'
                          ? 'bg-primary-100 text-primary-700'
                          : item.tag === '新片'
                            ? 'bg-accent-100 text-accent-700'
                            : item.tag === '公告'
                              ? 'bg-secondary-100 text-secondary-700'
                              : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 font-heading">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}